"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonListItem = void 0;
const react_1 = __importDefault(require("react"));
const SkeletonListItem = () => (react_1.default.createElement("li", { className: "flex items-center p-1 first:mt-0 bg-white border-1 border-b-0 border-grey-200 first:rounded-t-lg last:rounded-b-lg last:border-b" },
    react_1.default.createElement("div", { className: "animate-skeleton-pulse grid grid-cols-[24px_1fr_45px] w-full flex items-center p-4 rounded" },
        react_1.default.createElement("span", { className: "w-6 h-6 bg-gray-200 rounded-full" }),
        react_1.default.createElement("div", { className: "w-full d-flex flex-col mx-4" },
            react_1.default.createElement("div", { className: "mb-1 w-3/4 h-2 bg-gray-200 rounded" }),
            react_1.default.createElement("div", { className: "w-1/2 h-2 bg-gray-200 rounded" })),
        react_1.default.createElement("div", { className: "ml-auto mx-4 w-12 h-2 bg-gray-200 rounded" }))));
exports.SkeletonListItem = SkeletonListItem;
